export const comments_4791872 = {"data":{"data":[],"links":{}}}